var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Controller } from "react-hook-form";
import { useIntl } from "react-intl";
import { RecekSelect } from "../../inputs/RecekSelect";
/**
 * Shared ISBN/ISMN registration agency select for report forms.
 * Works with any RegistrationAgencyEnum (Piid, Wipo, Ipa, Progress, etc.)
 * since they all share the same "ISBN"/"ISMN" string values.
 */
export var RegistrationAgencySelect = function (_a) {
    var control = _a.control, name = _a.name, _b = _a.showLabel, showLabel = _b === void 0 ? true : _b;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Controller, { control: control, name: name, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return (React.createElement(RecekSelect, __assign({}, field, { labelId: "ui-br-agency.outputs.common.field.registrationAgency", showLabel: showLabel, error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, required: true }),
                React.createElement("option", { value: "ISBN" }, formatMessage({
                    id: "ui-br-agency.outputs.common.registrationAgency.isbn",
                })),
                React.createElement("option", { value: "ISMN" }, formatMessage({
                    id: "ui-br-agency.outputs.common.registrationAgency.ismn",
                }))));
        } }));
};
